import LocationsTableReducer from "./reducers/LocationsTableReducer";
import LocationsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import OrderV2LocationSelectModal from "./modals/OrderV2LocationSelectModal";

export const moduleName = "orderv2.locations";
export const url = "locations";
export const groupsUrl = `${url}/groups`;

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["orderv2.locations.read"]) {
        config.active = true;

        store.reducerManager?.add(
            "OrderV2LocationTable",
            LocationsTableReducer,
        );
        store.injectSaga?.("OrderV2LocationsSaga", LocationsSaga);
        registerModals({
            OrderV2LocationSelectModal,
        });
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="OrderV2/Locations/pages/LocationsIndexPage" />
            ),
        });
    }

    if (permissions["orderv2.locations.create"]) {
        routing.push({
            path: `${url}/create`,
            element: (
                <AsyncComponent path="OrderV2/Locations/pages/LocationsCreatePage" />
            ),
        });
    }
    if (permissions["orderv2.locations.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="OrderV2/Locations/pages/LocationsEditPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
